import user from './user';
import merchant from './merchant';

export default { user, merchant };
